import { useEffect } from "react";
import "./App.css";
import Router from "./Component/Router/Router";
import { AuthProvider } from "./context/Authcontext";

function App() {
  useEffect(() => {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    const elements = new Set();

    const observer = reduceMotion
      ? null
      : new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const delay = Number(entry.target.dataset.aosDelay || 0);
              window.setTimeout(() => entry.target.classList.add("aos--in"), delay);
              observer?.unobserve(entry.target);
            });
          },
          { threshold: 0.14, rootMargin: "0px 0px -10% 0px" }
        );

    const bindElements = () => {
      const nodes = Array.from(document.querySelectorAll("[data-aos]"));
      nodes.forEach((node) => {
        if (node.dataset.aosBound === "true") return;
        node.dataset.aosBound = "true";
        elements.add(node);
        if (reduceMotion) {
          node.classList.add("aos--in");
        } else {
          observer?.observe(node);
        }
      });
    };

    bindElements();

    const mutationObserver = new MutationObserver(() => {
      bindElements();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      mutationObserver.disconnect();
      observer?.disconnect();
      elements.clear();
    };
  }, []);

  return (
    <div className="App" style={{marginTop:"100px"}}>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </div>
  );
}

export default App;
